import { render, staticRenderFns } from "./CusNav.vue?vue&type=template&id=ecf1b9d6&scoped=true&"
import script from "./CusNav.vue?vue&type=script&lang=js&"
export * from "./CusNav.vue?vue&type=script&lang=js&"
import style0 from "./CusNav.vue?vue&type=style&index=0&id=ecf1b9d6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf1b9d6",
  null
  
)

export default component.exports